Namespace 'Customer.Filters'

class Customer.Filters.EditFilterInteractonsTabView extends Backbone.View
  className: 'filter-interactions-container'

  initialize: ({filter, sentiments, newQuery, tags, editable}) ->
    @sentimentsCardView = new Customer.Filters.SentimentsCardView({filter, sentiments, newQuery})
    @tagsCardView = new Customer.Filters.TagsCardView({filter, newQuery, tags, editable})
    @keywordsCardView = new Customer.Filters.KeywordsCardView({newQuery})
    @listenTo(@sentimentsCardView, 'sentiments:checkbox:clicked', => @trigger('sentiments:checkbox:clicked'))

  render: ->
    @$el.append(@sentimentsCardView.render().el)
    @$el.append(@tagsCardView.render().el)
    @$el.append(@keywordsCardView.render().el)
    @

  onApply: ->
    @keywordsCardView.onApply()

  updateTags: ->
    @tagsCardView.updateTags()
